import { useEffect, useState } from 'react';
import type { VoidFunctionComponent } from 'react';

import MultiSelectFilter from '../../../generic/Filter/MultiSelectFilter';
import useOrgLabels from '../../../../hooks/deprecatedAPI/useOrgLabels';
import type { Label } from '../../../../../shared/labels';
import type { MultiSelectFilterOption } from '../../../generic/Filter/MultiSelectFilter';

const labelsToOptions = (labels: Label[]): MultiSelectFilterOption[] => {
  return labels.map(l => ({ label: l.label, value: l.label }));
};

const stringsToOptions = (strings: string[]): MultiSelectFilterOption[] => {
  return strings.map(s => ({ label: s, value: s }));
};

type Props = {
  filterLabels: string[];
  onChange: (items: MultiSelectFilterOption[]) => void;
  testId?: string;
};

/**
 * This component handles a multi-select filter for Project Labels. The component will fetch and select the organization's
 * labels through the Projects v2 Redux store.
 * @param {string[]} filterLabels - The labels that the user has selected.
 * @param {(items: MultiSelectFilterOption[]) => void} onChange - The function to call when the user changes their selections.
 * @param {string} [testId] - The test ID. Mainly used for Selenium testing.
 */
const ProjectLabels: VoidFunctionComponent<Props> = ({
  filterLabels,
  onChange,
  testId,
}) => {
  const labels = useOrgLabels();

  // keep select options in sync with org labels
  const [options, setOptions] = useState<MultiSelectFilterOption[]>([]);
  useEffect(
    () => setOptions(labelsToOptions(labels)),
    [labels]);

  return (
    <MultiSelectFilter
      title="Labels"
      placeholder="Select labels..."
      values={stringsToOptions(filterLabels)}
      options={options}
      onChange={onChange}
      testId={testId}
    />
  );
};

export default ProjectLabels;
